import { createRoot } from 'react-dom/client';
import App from './views/main';
import Util from './script/util';
import zhCN from 'antd/locale/zh_CN';
import { ConfigProvider, App as AntdApp } from 'antd';
import ErrorBoundary from './components/errorBoundary';
import MonkeyPatchModal from './components/MonkeyPatchModal/index.jsx';
import { _init_ctx_path } from './store/Action';
// import 'core-js';
// import 'react-app-polyfill/ie9';
import './style/base.scss';
import './style/grade.scss';

import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.locale('zh-cn');
dayjs.extend(duration); // dayjs 插件，时间长度，用于倒计时
import "./script/eleStarupParams";

function _website_init(rootConfig) {
  window.browserInfo = Util.getBrowserInfo();
  if (Util.isMobileEnv()) {
    //手机访问重定向
    window.location.href = rootConfig.mobilePath;
  } else if (
    window.browserInfo.name == 'safari' ||
    window.browserInfo.name == 'opera'
  ) {
    window.location.href = rootConfig.mainWebSite;
  } else {
    if (
      window.browserInfo.name == 'chrome' ||
      window.browserInfo.name == 'firefox' ||
      window.browserInfo.name == 'Edge'
    ) {
      if (!window.STMatrixAsyn) {
        //声网SDK
        var rtc = document.createElement('script');
        rtc.src = '/assets/lib/agora/AgoraRTCSDK-3.6.11.js';
        rtc.onload = function () {
          //关闭本地日志
          window.AgoraRTC.Logger.setLogLevel(window.AgoraRTC.Logger.ERROR);
          //打开服务端日志
          window.AgoraRTC.Logger.disableLogUpload();
        };
        document.body.appendChild(rtc);
        window._ARTC = true;
      }
      //SVGA动画
      var svga = document.createElement('script');
      svga.src = '/assets/lib/svga/svga.min.js';
      document.body.appendChild(svga);
      window._SVGA = true;
      // SVGA音频
      var svgaScound = document.createElement('script');
      svgaScound.src = '/assets/lib/svga/howler.core.min.js';
      document.body.appendChild(svgaScound);
    }
    /* 极验SDK */
    var gtSdk = document.createElement('script');
    gtSdk.src = '/assets/lib/gt/gt.0.4.9.js';
    document.body.appendChild(gtSdk);

    /* 日志SDK */
    if (process.env.CLIENT_ENV === 'development') {
      const prefix = process.env.NODE_ENV === 'development' ? "https://test-play.daidaidj.com" : "";
      // const prefix = "http://127.0.0.1:8989";
      const logSdk = document.createElement('script');
      logSdk.src = prefix + '/a/r/static/js/v1.0.1/index.global.js';
      document.body.appendChild(logSdk);
      logSdk.onload = () => {
        if (!window.WebEyeLogs) return;
        const consolePlugin = new window.WebEyeLogs.ConsolePlugin();
        const errorPlugin = new window.WebEyeLogs.ErrorPlugin();
        const customPlugin = new window.WebEyeLogs.CustomPlugin();
        const requestPlugin = new window.WebEyeLogs.RequestPlugin({
          filterUrlWhite: ["yunxinfw.com", "netease.im"],
        });
        const whiteScreenPlugin = new window.WebEyeLogs.WhiteScreenPlugin();
        const resourcePlugin = new window.WebEyeLogs.ResourcePlugin();
        const recordPlugin = new window.WebEyeLogs.RecordPlugin({
          recordOptions: {
            checkoutEveryNms: 30000,
            checkoutEveryNth: 500,
            collectFonts: false,
            recordCrossOriginIframes: false,
          },
          maxDuration: 60000,
          bufferTime: 20000,

          snapshotInterval: 10000,
          snapshotTimeout: 5000,

          maxStorageSize: 1024 * 1024 * 1024, // 1GB
        });
        const monitor = new window.WebEyeLogs.Monitor({
          debug: process.env.CLIENT_ENV === 'development',
          logLevel: 2,
          appKey: "68918990be38aa23f4bae029",
          reportUrl: prefix + "/a/r",
        });
        monitor.use(consolePlugin)
        monitor.use(errorPlugin)
        monitor.use(customPlugin)
        monitor.use(requestPlugin)
        monitor.use(whiteScreenPlugin)
        monitor.use(resourcePlugin)
        monitor.use(recordPlugin)
        monitor.install();
        window._monitor_ = {};
        window._monitor_.consolePlugin = consolePlugin;
        window._monitor_.errorPlugin = errorPlugin;
        window._monitor_.requestPlugin = requestPlugin;
        window._monitor_.customPlugin = customPlugin;
        window._monitor_.whiteScreenPlugin = whiteScreenPlugin;
        window._monitor_.resourcePlugin = resourcePlugin;
        window._monitor_.recordPlugin = recordPlugin;
        window._monitor_.main = monitor;
      }
    }

    createRoot(document.getElementById('root')).render(
      <ConfigProvider
        locale={zhCN}
        wave={{ disabled: true }}
        theme={{
          token: {
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
            colorTextPlaceholder: '#bfbfbf', // 控制占位文本的颜色。
            // colorBgBase: "rgba(155, 155, 155, 0.2)", // 背景色梯度的基础变量
            colorText: 'rgba(0, 0, 0, 0.65)', // 	最深的文本色。为了符合W3C标准，默认的文本颜色使用了该色，同时这个颜色也是最深的中性色。
            colorIconHover: '#bfc0d6', // 控制弱操作图标在悬浮状态下的颜色，例如 allowClear 或 Alert 关闭按钮。
            colorTextQuaternary: '#bfc0d6', // 第四级文本色是最浅的文本色，例如表单的输入提示文本、禁用色文本等。
          },
          components: {
            Popover: {
              titleMinWidth: 100, // 气泡卡片标题最小宽度
            },
            Select: {
              selectorBg: 'rgba(155, 155, 155, 0.2)',
              hoverBorderColor: 'rgba(155, 155, 155, 0.8)',
            },
          },
        }}
      >
        <ErrorBoundary>
          <AntdApp>
            <MonkeyPatchModal />
            <App />
          </AntdApp>
        </ErrorBoundary>
      </ConfigProvider>
    );
  }
  if (process.env.LANG !== 'zh_CN') {
    //谷歌统计
    let s1 = document.createElement('script');
    s1.async = true;
    s1.src = 'https://www.googletagmanager.com/gtag/js?id=UA-160605539-1';
    let s2 = document.createElement('script');
    s2.innerHTML = `window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-160605539-1');`;
    let insertPos = document.getElementsByTagName('script')[0];
    insertPos.parentNode.insertBefore(s1, insertPos);
    insertPos.parentNode.insertBefore(s2, insertPos);
    //facebook像素
    let s3 = document.createElement('script');
    s3.innerHTML = `!function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '260044798689171');
        fbq('track', 'PageView');`;
    insertPos.parentNode.insertBefore(s3, insertPos);
  }
}

(function () {
  window.ServiceTimeStamp = 0;
  window.alert = window.confirm = window.prompt = () => {};
  const { CLIENT_ENV } = process.env;
  const isDev = CLIENT_ENV === 'development'; // 测试环境关闭域名替换
  _init_ctx_path(isDev).then((config) => {
    _website_init(config);
  });

  function clickWindow() {
    window.documentFirst = true;
    // 移除监听
    document.removeEventListener('click', clickWindow, true);
  }


  // 添加监听，避免 mp4 动效无法播放
  document.addEventListener('click', clickWindow, true);
  if (
    process.env.NODE_ENV === 'production' &&
    process.env.CLIENT_ENV === 'production'
  ) {
    // 阻止控制台
    let preventConsole = document.createElement('script');
    preventConsole.src = '/assets/lib/prevent_console.js?v=' + Date.now();
    document.body.appendChild(preventConsole);
  }
})();
